// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"75c66c43","239":"14223832","453":"99dcf01f","455":"cd9358ff"}[chunkId] + ".chunk.js";
};